// src/components/GATracker.tsx
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

// Inisialisasi GA4 sekali saja di luar komponen
ReactGA.initialize("G-94PDN2P1B1"); // Ganti dengan Measurement ID Anda

const GATracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Kirim pageview setiap kali URL berubah
        ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }, [location]);

    // Outlet ini penting! Ini tempat halaman-halaman website Anda akan muncul
    return <Outlet />;
};

export default GATracker;